var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('banner'),_vm._v(" "),_c('business'),_vm._v(" "),_c('div',{staticStyle:{"background":"#fcfcfc","padding-top":"60px"}},[_c('news')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }